export default __webpack_public_path__ + "static/media/alert.843061b9.svg";